import { cn } from '@zealot/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { GripVertical } from 'lucide-react';

const dragHandleVariants = cva(
  'shrink-0 cursor-grab touch-none text-muted-foreground/50 outline-none transition-colors hover:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring/50',
  {
    variants: {
      size: {
        sm: '[&>svg]:size-3.5',
        default: '[&>svg]:size-4',
      },
    },
    defaultVariants: { size: 'default' },
  },
);

type DragHandleProps = Omit<React.ComponentProps<'button'>, 'ref'> &
  VariantProps<typeof dragHandleVariants> & {
    // why: useSortableItem splits the draggable node from its grab target — handleRef must land on
    // why: the button, not the row, or the whole row becomes the drag affordance.
    handleRef?: (node: HTMLElement | null) => void;
    handleProps?: Record<string, unknown>;
    label: string;
  };

// gloss
export const DragHandle = ({ handleRef, handleProps, label, size, className, ...props }: DragHandleProps) => (
  <button
    type="button"
    ref={handleRef}
    aria-label={label}
    data-slot="drag-handle"
    className={cn(dragHandleVariants({ size, className }))}
    {...handleProps}
    {...props}
  >
    <GripVertical aria-hidden />
  </button>
);

export { dragHandleVariants };
